import { FC } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { AttendanceTimelineItem } from "src/apis/dashboardAttendance";
import { formatDateToBR } from "src/utils/date";
import ChartCard from "./ChartCard";
import { STATUS_COLORS } from "./constants";

type AttendanceTimelineChartProps = {
  data: AttendanceTimelineItem[];
};

const AttendanceTimelineChart: FC<AttendanceTimelineChartProps> = ({
  data,
}): JSX.Element => {
  return (
    <ChartCard title="Atendimentos por dia" isEmpty={data.length === 0}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: -16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={formatDateToBR} fontSize={12} />
          <YAxis allowDecimals={false} fontSize={12} />
          <Tooltip labelFormatter={(value) => formatDateToBR(String(value))} />
          <Legend />
          <Line
            type="monotone"
            dataKey="completed"
            name="Realizados"
            stroke={STATUS_COLORS.completed}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="scheduled"
            name="Marcados"
            stroke={STATUS_COLORS.scheduled}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="cancelled"
            name="Cancelados"
            stroke={STATUS_COLORS.cancelled}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="no_show"
            name="Faltas"
            stroke={STATUS_COLORS.no_show}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default AttendanceTimelineChart;
